<template>
  <div class="newsDetails">
    <!-- 新闻详情 -->
    <div class="all-center-box">
      <div class="w-1500">
        <div class="address-box w-100">
          <router-link to="/">首页</router-link> /
          <router-link :to="`/newsCenter?id=${newActive}`"
            >新闻中心</router-link
          >
        </div>
        <div class="page-center-box w-100">
          <div class="page-left">
            <div class="box-info1 w-100">新闻中心</div>
            <div class="box-info2 w-100">
              <span
                :class="{ active: newActive === item.type }"
                :key="item.label"
                v-for="(item, index) in nesList"
                @click="refresh(item)"
                >{{ item.label }}</span
              >
            </div>
          </div>
          <div class="page-right">
            <div class="news-info w-100">
              <div class="top-box w-100">
                <span style="font-size: 1.8rem;">{{ detailsArry.title }}</span>
                <p>时间：{{ detailsArry.lastTime }}</p>
              </div>
              <div
                class="cen-box w-100"
                v-if="detailsArry.text"
                v-html="detailsArry.text"
              ></div>
              <div class="lower-box w-100 between-center">
                <template v-if="hasPrevious">
                  <em @click="prevChange" style="pointer-events: auto; display: flex;">
                    <span>←上一篇</span>
                    <span style="width: 200px;overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1;">
                      《{{ previousNews ? previousNews.title : '' }}》
                    </span>
                  </em>
                </template>
                <template v-else>
                  <em style="pointer-events: none">没有上一篇了</em>
                </template>
                <router-link
                  :to="{ path: '/newsCenter', query: { id: newActive } }"
                  >返回列表</router-link
                >
                <template v-if="hasNext">
                  <em @click="nextChange" style="pointer-events: auto; display: flex;">
                    <span>下一篇→</span>
                    <span style="width: 200px;overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1;">
                      《{{ nextNews ? nextNews.title : '' }}》
                    </span>
                  </em>
                </template>
                <template v-else>
                  <em style="pointer-events: none">没有下一篇了</em>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMessageListMore, getMessageDetails } from '@/common/http.js'
export default {
  name: 'newsDetails',
  inject: ['reload'],
  data() {
    return {
      detailsArry: [],
      articleId: '',
      prevPointerEvents: true,
      nextPointerEvents: true,
      currentPage: 1,	//当前页数
      pageSize: 10,	//当前条数
      totalPage: 1,	//总页数
      nesList: [
        {
          label: '通知公告',
          type: 1
        },
        {
          label: "新闻资讯",
          type: 5
        }
      ],
      newActive: 1,
      pageIndex: 1, // 当前数据所在位置
      newsList: []
    }
  },
  computed: {
    previousNews() {
      if (this.pageIndex > 0) {
        return this.newsList[this.pageIndex - 1];
      }
      if (this.pageIndex === 0 && this.currentPage !== 1) {
        return this.nesList[this.pageSize - 1]
      }
      return null;
    },
    nextNews() {
      if (this.pageIndex < this.newsList.length - 1) {
        console.log('1', this.newsList[this.pageIndex + 1])
        return this.newsList[this.pageIndex + 1];
      }
      if (this.pageSize - 1 == this.pageIndex) {
        console.log('2', this.newsList[0])
        return this.newsList[0];
      }
      return null;
    },
    hasPrevious() {
      return this.previousNews !== null;
    },
    hasNext() {
      return this.nextNews !== null;
    }
  },
  mounted() {
    this.articleId = this.$route.query.id;
    this.newActive = this.$route.query.type * 1;
    this.currentPage = this.$route.query.pageIndex * 1;
    this.pageIndex = this.$route.query.index * 1;
    this.newsArticle(this.newActive);
    this.getNewsList();
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  watch: {
    $route(to, from) {
      // this.$router.go(0)
      this.reload();
    }
  },
  methods: {
    newsArticle(type) {
      getMessageDetails({
        pageSize: 1,
        pageIndex: 1,
        type,
        id: this.articleId
      }).then(res => {
        if (res.result) {
          this.detailsArry = res.data;
        }
      })
    },
    // 请求当前的页码对应数据
    getNewsList() {
      getMessageListMore({
        pageSize: this.pageSize,
        pageIndex: this.currentPage,
        type: this.newActive,
      }).then(res => {
        this.newsList = res.data.rows;
        this.totalPage = res.data.total;
      })
    },
    prevChange() {
      this.detailsArry = this.previousNews;
      this.pageIndex -= 1;
      this.$nextTick(() => {
        console.log('prevChange')
       window.scrollTo(0, 0)
      })
      if (this.pageIndex === 0 && this.currentPage !== 1) {
        this.pageIndex = this.pageSize - 1;
        this.currentPage -= 1;
        this.getNewsList();
      }
    },
    nextChange() {
      // 最后一页最后一条
      this.detailsArry = this.nextNews;
      this.pageIndex += 1;
      this.$nextTick(() => {
        console.log('nextChange')
        window.scrollTo(0, 0)
      })
      if (this.pageSize - 1 == this.pageIndex) {
        this.pageIndex = 0;
        this.currentPage += 1;
        this.getNewsList();
      }
    },
    refresh(item) {
      // this.newActive = item.type;
      this.$router.push({
        path: '/newsCenter',
        query: { id: item.type }
      })
    }
  },
  filters: {
    intercept(str) {
      return str.substr(0, 10);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/newsCenter/newsDetails.vue